import { render, staticRenderFns } from "./WonenObject.vue?vue&type=template&id=086549f4&"
import script from "./WonenObject.vue?vue&type=script&lang=ts&"
export * from "./WonenObject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports